import { Spinner } from "@/components/ui/spinner";
import { Copy } from "lucide-react";
import { CATEGORY_LABELS } from "../../monthly-summary/types/category.types";
import { useBudgetStore } from "../store/useBudgetStore";

export default function CarryForwardBanner() {
  const { template, saving, applyTemplate, dismissTemplate } = useBudgetStore();
  if (!template) return null;

  const fmt = (n: number) =>
    n.toLocaleString("th-TH", { minimumFractionDigits: 0 });

  return (
    <div className="rounded-2xl border border-primary/30 bg-primary/5 p-4 sm:p-6">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Copy className="w-4 h-4 text-primary" />
        </div>
        <div>
          <p className="text-[15px] font-semibold text-foreground">
            Reuse last month's budget?
          </p>
          <p className="text-[13px] text-muted-foreground mt-0.5">
            You had a budget set last month. Use it as a starting point —
            spending resets to zero.
          </p>
        </div>
      </div>

      <div className="rounded-xl bg-card border border-border p-4 mb-4 flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="text-[13px] text-muted-foreground">
            Overall budget
          </span>
          <span className="text-[14px] font-semibold text-foreground [font-variant-numeric:tabular-nums]">
            ฿{fmt(template.overallAmount)}
          </span>
        </div>
        {template.categoryBudgets.map((c) => (
          <div key={c.category} className="flex justify-between items-center">
            <span className="text-[13px] text-muted-foreground">
              {CATEGORY_LABELS[c.category]}
            </span>
            <span className="text-[13px] text-foreground [font-variant-numeric:tabular-nums]">
              ฿{fmt(c.amount)}
            </span>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={applyTemplate}
          disabled={saving}
          className="inline-flex items-center justify-center gap-1.5 px-5 py-2 rounded-xl bg-primary text-primary-foreground text-[13px] font-medium transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {saving && <Spinner className="size-3.5" />}
          {saving ? "Applying…" : "Reuse this budget"}
        </button>
        <button
          onClick={dismissTemplate}
          disabled={saving}
          className="text-[13px] text-muted-foreground hover:text-foreground transition-colors disabled:opacity-50"
        >
          Start fresh
        </button>
      </div>
    </div>
  );
}
